"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddNewDeliveryButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _BigButton = require("./BigButton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AddNewDeliveryButton = ({
  label,
  onClick,
  testId,
  variant = 'large'
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  if (variant === 'small') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SmallButton, {
      onClick: onClick,
      ...getTestIdProps(testId),
      children: label
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_BigButton.BigButton, {
    onClick: onClick,
    ...getTestIdProps(testId),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      fontWeight: "bold",
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
      className: _BigButton.withHoverBackgroundClass,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Add, {
        fontSize: "inherit"
      })
    })]
  });
};
exports.AddNewDeliveryButton = AddNewDeliveryButton;